import * as R from 'ramda'
import { handleError } from '../../reducers/error'
import { showSuccessSnackbar } from '../../reducers/success'
import { loadingAction } from '../../reducers/loader'

export const asyncStarted = (tag) => ({ type: `${tag}_STARTED` })
export const asyncSuccess = (tag, params) => ({ type: `${tag}_SUCCESS`, ...params })
export const asyncFailure = (tag, error) => ({ type: `${tag}_FAILURE`, error })

export const call = (meta) => (dispatch) => {
  const { endpoint, inputs, action, messages } = meta
  dispatch(loadingAction(true))
  dispatch(asyncStarted(action))
  return endpoint(inputs)
    .then((success) => {
      dispatch(loadingAction(false))
      dispatch(asyncSuccess(action, success))
      dispatch(showSuccessSnackbar(messages.success));
      return success
    })
    .catch((error) => {
      dispatch(loadingAction(false))
      dispatch(asyncFailure(action, error))
      handleError(dispatch, error, messages.id, messages.failure)
      throw error
    })
}

export const clearError = state => R.assoc('error', {}, state)
export const startLoading = state => R.assoc('loading', true, state)
export const stopLoading = state => R.assoc('loading', false, state)
export const saveErrorMsg = (state, action, message) => R.assoc(
  'error',
  {
    message,
    error: action.error,
  },
  state)

export const reducer = (initialState, tag, success, failure) => (state = initialState, action) => {
  switch (action.type) {
    case `${tag}_STARTED`: {
      return startLoading(clearError(state))
    }
    case `${tag}_SUCCESS`: {
      return success(stopLoading(state), action)
    }
    case `${tag}_FAILURE`: {
      return saveErrorMsg(stopLoading(state), action, failure)
    }
    default:
      return state
  }
}
